import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEmailTemplate, IEmailTemplateInitialState } from "./emailTemplateModal";
import {
  ActiveInactiveEmailTemplate,
  createEmailTemplate,
  deleteEmailTemplate,
  getAllActiveEmailTemplate,
  getAllEmailTemplate,
  getEmailTemplateByID,
  updateEmailTemplate,
} from "./services/emailTemplate.services";

const initialState: IEmailTemplateInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  EmailTemplateID: null,
  EmailTemplateList: [],
  EmailTemplateDetail: {
    ID: null,
    Subject: "",
    Content: "",
    IsActive: 1,
  },
};

const emailTemplateSlice = createSlice({
  name: "emailTemplate",
  initialState,
  reducers: {
    clearEmailTemplateDetails: (state) => {
      state.EmailTemplateDetail = initialState.EmailTemplateDetail;
    },
    setEmailTemplateID: (state, action) => {
      state.EmailTemplateID = action.payload;
    },
    clearEmailTemplateID: (state) => {
      state.EmailTemplateID = initialState.EmailTemplateID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllEmailTemplate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllEmailTemplate.fulfilled,
      (state, action: PayloadAction<IEmailTemplate[]>) => {
        state.loading = false;
        state.EmailTemplateList = action.payload || [];
      },
    );
    builder.addCase(getAllEmailTemplate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EmailTemplateList = [];
    });
    builder.addCase(createEmailTemplate.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createEmailTemplate.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createEmailTemplate.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateEmailTemplate.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateEmailTemplate.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateEmailTemplate.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteEmailTemplate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteEmailTemplate.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteEmailTemplate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getEmailTemplateByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getEmailTemplateByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.EmailTemplateDetail = action.payload;
    });
    builder.addCase(getEmailTemplateByID.rejected, (state, action) => {
      state.formLoading = false;
      state.EmailTemplateDetail = initialState.EmailTemplateDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveEmailTemplate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveEmailTemplate.fulfilled,
      (state, action: PayloadAction<IEmailTemplate[]>) => {
        state.loading = false;
        state.EmailTemplateList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveEmailTemplate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EmailTemplateList = [];
    });
    builder.addCase(ActiveInactiveEmailTemplate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveEmailTemplate.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveEmailTemplate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearEmailTemplateDetails,
  clearEmailTemplateID,
  setEmailTemplateID,
} = emailTemplateSlice.actions;
export default emailTemplateSlice.reducer;
